module.exports = __webpack_public_path__ + "img/focus.1ec127e6.jpg";